export interface WhoWeServeItem {
  id: "business" | "developers" | "partners" | "consumers";
  name: string;
  tagline: string;
  href: string;
}

export const whoWeServeItems: WhoWeServeItem[] = [
  {
    id: "business",
    name: "For Business",
    tagline: "Customer-facing voice and chat for sales, service, and support.",
    href: "/help-genie-for-business-solutions",
  },
  {
    id: "developers",
    name: "For Developers",
    tagline: "Build custom integrations and conversational workflows with APIs.",
    href: "/help-genie-for-developers",
  },
  {
    id: "partners",
    name: "For Partners",
    tagline: "Package and scale solutions on top of Help Genie infrastructure.",
    href: "/help-genie-for-partners",
  },
  {
    id: "consumers",
    name: "For Consumers",
    tagline: "Mobile app experiences for personal assets and custom genie collections.",
    href: "/help-genie-for-consumers",
  },
];
